<template>
  <div :class="{ 'booking-calendar-loading': showLoading }">
    <v-progress-circular
      v-if="showLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div class="calendar-section">
      <div class="row px-2 pt-1 pb-4 mx-0 mt-8 manual-search-section ">
        <div class="col-12 col-md-6 col-xxl-3 pb-0">
          <BrandDropdown
            v-model="brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"
          ></BrandDropdown>
          <div v-if="error.brand" class="text-error">
            {{ error.brand }}
          </div>
        </div>
        <div class="col-12 col-md-6 col-xxl-3 pb-0">
          <StoreDropdown
            v-model="storeSelected"
            :brandCode="brandSelected ? brandSelected.id : null"
            @setStore="setStore"
            @setStores="setStores"
            @setLoading="setStoresLoading"
          ></StoreDropdown>
          <div v-if="error.store" class="text-error">
            {{ error.store }}
          </div>
        </div>
        <div class="col-12 col-md-6 col-xxl-3 pb-0">
          Date
          <date-picker
            v-bind="$attrs"
            v-model="date"
            format="D MMMM yyyy"
            lang="en"
            :value="date"
            @change="date = $event"
          />
          <div v-if="error.date" class="text-error">
            {{ error.date }}
          </div>
        </div>
        <div class="col-12 col-md-6 col-xxl-3 pb-0 d-flex align-items-center justify-content-between" style="margin-top: auto">
          <div>
            Type
            <div style="margin: 0.6rem 0">
              <input type="radio" id="room" value="ROOM" v-model="filterType" />
              <label for="room">&nbsp;Room</label>
              <input
                type="radio"
                id="staff"
                value="STAFF"
                v-model="filterType"
                style="margin-left: 20px"
              />
              <label for="staff">&nbsp;Staff</label>
            </div>
          </div>
          <div class="p-2">
            <button
              class="btn btn-outline-primary"
              style="width: 100%; max-width: 131px; margin-top: 25px"
              @click="searchCalendar"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-6 mx-0 px-2 auto-search-section">
        <div class="col-6">
          Status
          <div class="booking-status">
            <input
                type="checkbox"
                id="status-booked"
                value="BOOKED"
                v-model="activeStatuses"
            />
            <div class="booking-status-booked"></div>
            <label for="status-booked" class="status-label">BOOKED</label>
            <input
                type="checkbox"
                id="status-used"
                value="USED"
                v-model="activeStatuses"
            />
            <div class="booking-status-used"></div>
            <label for="status-used" class="status-label">USED</label>
            <input
                type="checkbox"
                id="status-cancelled"
                value="CANCELLED"
                v-model="activeStatuses"
            />
            <div class="booking-status-cancelled"></div>
            <label for="status-cancelled" class="status-label">CANCELLED</label>
          </div>
        </div>
        <div
          class="col-6 pb-0 d-flex align-items-center justify-content-end"
          v-if="isSearch"
        >
          <button
            class="btn btn-outline-primary arrow-button"
            style="width: fit-content"
            @click="changeDate(-1)"
          >
            &#9664;
          </button>
          <span
            class="date-label"
            style="margin-left: 8px; margin-right: 8px; color: cornflowerblue"
            >{{ formattedDate }}</span
          >
          <button
            class="btn btn-outline-primary arrow-button"
            style="width: fit-content; margin-right: 10px"
            @click="changeDate(1)"
          >
            &#9654;
          </button>
        </div>
      </div>
      <div class="row">
        <DailyCalendar
            v-if="isSearch"
            :key="calendarKey"
            :events="filteredCalendarEvents"
            :resources="calendarResources"
        />
      </div>
      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h3>{{ message }}</h3>
          <div class="row text-center">
            <div class="col">
              <button class="btn-back" @click="showDialog = false">ปิด</button>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Booking/BrandDropdown";
import StoreDropdown from "components/Booking/StoreDropdown";
import DailyCalendar from "components/Booking/DailyCalendar";
import BookingService from "services/api/booking.service";
import DatePicker from "components/Datepicker/Datepicker.vue";
import {BookingCalendarStorageService} from "services/storage.service";

const STATUS_COLOR_MAP = {
  BOOKED: "#2196F3",
  USED: "#4CAF50",
  CANCELLED: "#CE0012",
  DEFAULT: "blue",
};

export default {
  components: {
    DatePicker,
    BrandDropdown,
    StoreDropdown,
    DailyCalendar,
  },

  data() {
    return {
      showDialog: false,
      isSearch: false,
      isLoading: false,
      isStoreLoading: false,
      message: null,
      date: null,
      dateSelected: null,
      brandSelected: null,
      storeSelected: null,
      filterType: "STAFF",
      items: [],
      calendarEvents: [],
      calendarResources: [],
      isMounted: true,
      activeStatuses: ["BOOKED", "USED", "CANCELLED"],
      calendarKey: 0,
      error: {
        brand: "",
        store: "",
        date: "",
      },
    };
  },
  computed: {
    formattedDate() {
      if (!this.dateSelected) return "";
      let date = new Date(this.dateSelected);
      let day = date.getDate();
      let month = date.toLocaleString("en-US", { month: "long" });
      let year = date.getFullYear();
      return `${day} ${month} ${year}`;
    },
    showLoading() {
      return this.isLoading || this.isStoreLoading;
    },
    filteredCalendarEvents() {
      return this.calendarEvents.filter(event =>
          this.activeStatuses.includes(event.status)
      );
    },
  },
  watch: {
    activeStatuses: {
      handler() {
        this.calendarKey++;
      },
      deep: true
    }
  },
  mounted() {
    let storedParams =
      JSON.parse(BookingCalendarStorageService.getStoredParams()) || {};
    if (storedParams) {
      this.brandSelected = storedParams.brandSelected || null;
      this.storeSelected = storedParams.storeSelected || null;
      this.date = storedParams.date || null;
      this.filterType = storedParams.filterType || 'STAFF';
    }
    if (
      this.brandSelected != null &&
      this.storeSelected != null &&
      this.date != null
    ) {
      this.getCalendar();
    }
  },
  methods: {
    getParams() {
      return {
        bookingDate: this.date,
        brandCode: this.brandSelected ? this.brandSelected.id : null,
        storeCode: this.storeSelected ? this.storeSelected.id : null,
        type: this.filterType,
      };
    },
    listStoredParams() {
      return {
        date: this.date,
        brandSelected: this.brandSelected,
        storeSelected: this.storeSelected,
        filterType: this.filterType,
      };
    },
    async getCalendar() {
      const param = this.getParams();
      await BookingCalendarStorageService.setStoredParams(
        this.listStoredParams()
      );

      await BookingService.getCalendar(param)
        .then((res) => {
          const data = res.data;
          if (data.resources.length > 0) {
            this.setCalendar(data);
          } else {
            throw new Error("Service store not found");
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
          this.showDialog = true;
          this.message = "ไม่พบข้อมูล";
        });
    },
    searchCalendar() {
      this.error.brand = this.brandSelected ? "" : "กรุณาระบุ";
      this.error.store = this.storeSelected ? "" : "กรุณาระบุ";
      this.error.date = this.date ? "" : "กรุณาระบุ";
      if (this.error.brand || this.error.store || this.error.date) return;
      this.dateSelected = this.date;
      this.isSearch = false;
      this.isLoading = true;
      this.getCalendar();
    },
    setBrand(brand) {
      this.brandSelected = brand || null;
      let storedParams =
        JSON.parse(BookingCalendarStorageService.getStoredParams()) || {};
      if (storedParams && this.isMounted) {
        this.storeSelected = storedParams.storeSelected || null;
        this.isMounted = false;
      } else {
        this.storeSelected = null;
      }
    },
    setBrands(brands) {
      brands.forEach((brand) => {
        if (brands.length === 1) {
          this.brandSelected = brand;
        }
      });
    },
    setStore(store) {
      this.storeSelected = store || null;
    },
    setStores(stores) {
      stores.forEach((store) => {
        if (stores.length === 1) {
          this.storeSelected = store;
        }
      });
    },
    setStoresLoading(isLoading) {
      this.isStoreLoading = isLoading;
    },
    setCalendar(data) {
      this.isSearch = true;
      this.calendarEvents = this.extractEvents(data);
      this.calendarResources = this.extractResources(data);
      this.calendarKey++; // Force re-render
    },
    extractEvents(data) {
      const date = new Date().toISOString().split("T")[0];
      return data.items
        .map((item) => ({
          id: item.id,
          text: item.name,
          start: date + " " + item.startTime + ":00",
          end: date + " " + item.endTime + ":00",
          resource: item.resourceId,
          barColor: STATUS_COLOR_MAP[item.status] || STATUS_COLOR_MAP.DEFAULT,
          status: item.status,
        }))
        .sort((a, b) => {
          const getSortKey = (item) => {
            const statusWeight = item.status === "CANCELLED" ? 0 : 1;
            return statusWeight * 100000 + item.id;
          };
          return getSortKey(a) - getSortKey(b);
        });
    },
    extractResources(data) {
      return data.resources
        .map((resource) => ({
          id: resource.id,
          name: resource.name,
        }))
        .sort((a, b) => a.id - b.id);
    },
    changeDate(days) {
      let currentDate = new Date(this.date);
      currentDate.setDate(currentDate.getDate() + days);
      this.date = currentDate.toISOString().split("T")[0];
      this.searchCalendar();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .container {
  max-width: unset !important;
}

::v-deep .calendar-container {
  height: calc(100vh - 370px) !important;
}

@media screen and (max-width: 1400px) {
  ::v-deep .calendar-container {
    height: calc(100vh - 470px) !important;
  }
}

::v-deep .calendar-container > div {
  height: 93% !important;
}

::v-deep .calendar-container > div > div:nth-child(2) {
  height: 100% !important;
}

.booking-calendar-loading > :not(:first-child) {
  pointer-events: none;
  opacity: 0.4;
}

.booking-status {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin: 0.6rem 0;
}

.booking-status-booked {
  width: 12px;
  height: 12px;
  background-color: #2196F3;
  border-radius: 50%;
}

.booking-status-used {
  width: 12px;
  height: 12px;
  background-color: #4CAF50;
  border-radius: 50%;
}

.booking-status-cancelled {
  width: 12px;
  height: 12px;
  background-color: #CE0012;
  border-radius: 50%;
}

.status-label {
  margin: 0;
  cursor: pointer;
  user-select: none;
}

input[type="checkbox"] {
  cursor: pointer;
}

.manual-search-section {
  box-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
  border: 1px solid rgb(192, 192, 192);
  background-color: rgb(249, 249, 249);
}

.auto-search-section {
  background-color: rgb(243, 243, 243);
  border: 1px solid rgb(192, 192, 192);
}
</style>
